import { useTexts } from './useTexts';
import { OutlinedSelectOptionType } from '@octano/global-ui';

export function useGetJustificationStatusOptions(): OutlinedSelectOptionType[] {
  const texts = useTexts();
  return [
    {
      label: texts.table.detail.justificationStatusOptions.pendingLabel,
      value: 'pending',
      icon: { name: 'information', color: 'info' },
    },
    {
      label: texts.table.detail.justificationStatusOptions.approvedLabel,
      value: 'approved',
      icon: { name: 'check', color: 'success' },
    },
    {
      label: texts.table.detail.justificationStatusOptions.deniedLabel,
      value: 'rejected',
      icon: { name: 'error', color: 'danger' },
    },
  ];
}
